// 用户查看或下载需要支付的内容时，创建订单
// 订单信息通过payment.vue展示给用户
// 订单包括普通订单（针对某次具体内容的查看或下载）和充值订单
// 订单信息不会直接保存
// 但后续会作为支付信息和消费信息记录的一部分，保存在account_consumption和account_wepaydeposit中
// 订单信息将通过deposit.js中的函数，调用微信创建支付二维码

//attach 类别-Code

import Vue from 'vue'
import Vuex from 'vuex'

import qs from "qs";
import axios from "axios";
import global_ from '@/misc/global.vue';

Vue.use(Vuex)

export const order = {
  namespaced: true,

  state: {
    // 单次基本信息
    onceInfo: {
      order_number: '', // 创建订单时的时间戳
      total_fee: 0, // 单位元
      body: '',
      attach: '',
      description: '', // 订单内容，记录消费内容
      category: '', // 订单类别，后续根据类别，确定后端接口
      code: '', // 代码,后续根据代码，确定需要下载的具体内容
      paymenturl: '支付/充值前请先登录'
    },

    // 充值订单信息
    rechargeInfo: {
      order_number: '', // 创建订单时的时间戳
      total_fee: 5000, //单位元
      body: '',
      attach: '',
      paymenturl: '支付/充值前请先登录'
    },
  },

  mutations: {
    // 设置订单标题和下载信息
    // 传递过来的参数为对象，包括标准代码和标准名称
    // 创建普通订单，单次支付
    // 传过来的参数为对象，包括支付金额和用户ID（当用户未登录时，为null）
    // 将这些参数传递给后端，后端将调用微信端，产生支付二维码字符串，
    // 支付二维码字符串将更新到paymenturl中，由payment.vue转化为二维码图片，供用户扫码支付
    setOnceInfo(state, params) {
      // 标准名称、法规名称或搜索的关键字
      Vue.set(state.onceInfo, 'description', params.description)
      // 是标准还是法规，'regulations_download'、'standards_download'、'standards_search_download'、'regulations_search_download'
      Vue.set(state.onceInfo, 'category', params.category)
      // 标准代码或法规代码
      Vue.set(state.onceInfo, 'code', params.code)
      // 以下四项参数需发给微信端，以获取支付二维码
      Vue.set(state.onceInfo, 'order_number', new Date().getTime())
      Vue.set(state.onceInfo, 'total_fee', params.total_fee)
      // 发给微信端的描述，与category对应，法规下载或标准下载
      Vue.set(state.onceInfo, 'body', params.body)
      if (params.userid == null) {
        Vue.set(state.onceInfo, 'paymenturl', '支付/充值前请先登录')
      } else {
        if (params.code == null || params.code == {} || params.code == "") {
          Vue.set(state.onceInfo, 'paymenturl', '没有需要支付的内容')
        } else {
          // 微信将随支付结果，回传回来，供后端数据库操作
          Vue.set(state.onceInfo, 'attach', JSON.stringify({
            category: params.category,
            code: params.code,
            id: params.userid
          }))
          var orderHistory = JSON.parse(localStorage.getItem('consumptionHistory'))
          var idx = localStorage.getItem('consumptionHistory') && orderHistory.findIndex((element) => {
            return element.code == params.code && element.category == params.category
          })
          if (idx == -1) {
            // 以下四项参数需发给微信端，以获取支付二维码
            let postData = qs.stringify({
              out_trade_no: 'o' + Math.random().toString(36).substr(2) + new Date().getTime(),
              total_fee: state.onceInfo.total_fee,
              body: state.onceInfo.body,
              attach: state.onceInfo.attach
            });
            axios({
              method: "post",
              async: false,
              url: global_.BAK_URL + "wePayDepositCreate/",
              data: postData
            }).then(response => {
              Vue.set(state.onceInfo, 'paymenturl', response.data)
            })
          } else {
            Vue.set(state.onceInfo, 'paymenturl', '您已购买，请点击历史记录表单中的链接下载')
          }
        }
      }
    },

    updateOnceInfo(state, params) {
      if (state.onceInfo.code == '' || state.onceInfo.code == null) {
        Vue.set(state.onceInfo, 'paymenturl', '没有需要支付的内容')
      } else {
        var orderHistory = JSON.parse(localStorage.getItem('consumptionHistory'))
        var idx = localStorage.getItem('consumptionHistory') && orderHistory.findIndex((element) => {
          return element.code == state.onceInfo.code && element.category == state.onceInfo.category
        })
        Vue.set(state.onceInfo, 'attach', JSON.stringify({
          category: state.onceInfo.category,
          code: state.onceInfo.code,
          id: params
        }))
        if (idx == -1) {
          // 以下四项参数需发给微信端，以获取支付二维码
          let postData = qs.stringify({
            out_trade_no: 'o' + Math.random().toString(36).substr(2) + new Date().getTime(),
            total_fee: state.onceInfo.total_fee,
            body: state.onceInfo.body,
            attach: state.onceInfo.attach
          });
          axios({
            method: "post",
            async: false,
            url: global_.BAK_URL + "wePayDepositCreate/",
            data: postData
          }).then(response => {
            Vue.set(state.onceInfo, 'paymenturl', response.data)
          })
        } else {
          Vue.set(state.onceInfo, 'paymenturl', '您已购买，请点击历史记录表单中的链接下载')
        }
      }
    },

    // 创建充值订单
    // 传过来的参数为对象，包括支付金额和用户ID（当用户未登录时，不能创建充值订单，由payment.vue控制）
    // 将这些参数传递给后端，后端将调用微信端，产生支付二维码字符串，
    // 支付二维码字符串将更新到paymenturl中，由payment.vue转化为二维码图片，供用户扫码支付
    setRechargeInfo(state, params) {
      if (params.userid == null) {
        Vue.set(state.rechargeInfo, 'paymenturl', '支付/充值前请先登录')
      } else {
        let postData = qs.stringify({
          out_trade_no: 'r' + Math.random().toString(36).substr(2) + new Date().getTime(),
          total_fee: params.total_fee,
          body: '充值',
          attach: JSON.stringify({
            id: params.userid
          })
        });
        axios({
          method: "post",
          async: false,
          url: global_.BAK_URL + "wePayDepositCreate/",
          data: postData
        }).then(response => {
          Vue.set(state.rechargeInfo, 'paymenturl', response.data)
        })
      }
    }
  },

  actions: {
    // 创建普通订单，单次支付
    // 其他参数利用onceInfo的数据
    // 需要加上当前用户ID，如果用户未登录，id自动为null
    setOnceInfo: (context, params) => {
      params.userid = context.rootState.users.userInfo.userid
      context.commit("setOnceInfo", params)
    },

    updateOnceInfo: (context) => {
      var params = context.rootState.users.userInfo.userid
      context.commit('updateOnceInfo', params)
    },

    // 创建充值订单
    // 参数为支付金额
    // 再附件onceInfo的数据
    setRechargeInfo: (context, params) => {
      var par = {
        'userid': context.rootState.users.userInfo.userid,
        'total_fee': params
      }
      context.commit("setRechargeInfo", par)
    },

    // 余额支付
    // params 为需支付金额
    consumptionByAccount(context, params) {
      var orderHistory = JSON.parse(localStorage.getItem('consumptionHistory'))
      var idx = localStorage.getItem('consumptionHistory') && orderHistory.findIndex((element) => {
        return element.code == params.code && element.category == params.category
      })
      if (idx == -1) {
        // 判断用户余额是否足够
        if (
          context.rootState.users.userInfo.account1 + context.rootState.users.userInfo.account2 >=
          parseInt(params.total_fee)
        ) {
          let postData2 = qs.stringify({
            out_trade_no: 'a' + Math.random().toString(36).substr(2) + new Date().getTime(),
            total_fee: params.total_fee,
            attach: params.attach
          })
          axios({
            method: "post",
            async: false,
            url: global_.BAK_URL + "consumptionByAccount/",
            data: postData2,
            dataType: "json"
          }).then(response => {
            alert(response.data)
            if (response.data == '支付成功') {
              context.commit('users/getConsumptionHistory', {}, {
                root: true
              })
              // 更新缓存中的用户信息
              context.commit('users/getUserInfo', {}, {
                root: true
              })
            }
          })
        } else {
          alert('余额不足， 请充值。')
        }
      } else {
        alert('您已购买，请点击历史记录表单中的链接下载。')
      }
    }
  }
}